import Colors from 'styles/colors';
import { transparentize } from 'color2k';

export const rootTheme = {
  radius: {
    none: 0,
    xxs: 2,
    xs: 4,
    sm: 6,
    md: 8,
    lg: 10,
    xl: 12,
    xxl: 16,
    xxxl: 20,
    xxxxl: 24,
    full: 9999,
  },
  themeName: 'Sirona Default',
  spacing: 6,
  typography: {
    htmlFontSize: 10,
    fontSize: 12,
  },
  palette: {
    mode: 'dark',
    preferredHighlight: Colors.blue2,
    borderDefaultColor: '#0D47A1',
    borderActiveColor: '#2196F3',
    primary: { main: Colors.blue3 },
    background: {
      default: Colors.gray1,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { fontSize: '10px' }, // 1rem = 10px
      },
    },
    MuiTypography: {
      styleOverrides: {
        h3: {
          fontSize: 16,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: Colors.gray2,
          backgroundImage: 'none',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: Colors.gray2,
          backgroundImage: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
        notchedOutline: {
          borderRadius: 4,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: Colors.gray10,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.16)',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        colorSecondary: {
          '&.Mui-checked': {
            color: Colors.blue3,
            '&:hover': {
              backgroundColor: transparentize(Colors.blue3, 0.8) as string,
            },
          },

          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: Colors.blue5,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: 24,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&& .MuiSvgIcon-root': {
            fontSize: 24,
          },
        },
      },
    },
  },
} as const;
